// extracted by mini-css-extract-plugin
export default {"loading_container":"List_loading_container__eGXO5","message_list":"List_message_list__kjChk","loading":"List_loading__4eMQB"};